/** @module Apparel/AssortmentMatrixRenderer */
define([
	"dojo/_base/declare",
	"dojo/dom-style",
	"underscore",
	"csi/def",
	"csi/heading/Renderer",
	"csi/locale",
	"csi/store/Nodes",
	"csi/view",
	"csi/xml"
], function(declare,domStyle,_,def,Renderer,locale,Nodes,csiView,xml) {
	
	return declare(Renderer, {
		allowEmpty: true,
		
		/** @property {boolean} stylesOnly - set to true to show only Style placements in assortment BOM */ 
		stylesOnly: false,
		
		/** @property {boolean} transpose - set to true to transpose matrix so Colorways show as rows */
		transpose: false,
		
		/**
		 * @override
		 * Render table of assortment styles
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			// do not render Heading label
			h.labelSeparator = null;
			
			var transpose = this.transpose;
			var style = ctx.getNode();
			var cache = ctx.cache;
			var bom = cache.get(style.AssortmentBOM);
			if (!bom) {
				return false;
			}
			
			var rev = cache.get(bom.CurrentRevision);
			if (!rev || !rev.BOMProductColors.length) {
				return false;
			}
			
			var items = _.filter(cache.getNodes(rev.Items), function(item) {
				return xml.isValidURL(item.Actual) && (!this.stylesOnly || item.ForStyle);
			}, this);
			
			if (!items.length) {
				return false;
			}
			
			var itemStore = new Nodes({
				cachingStore: cache,
				data: items
			});
			
			var colorStore = new Nodes({
				cachingStore: cache,
				data: cache.getNodes(rev.BOMProductColors)
			});
			
			var defView = def.getNodeViewDef(rev, transpose ? "SlimAssortmentTransposed" : "SlimAssortment");
			var view = csiView.newView(defView, rev, {
				cacheView: cache,
				disableOnClick: true,
				dynamicColumnWidths: true,
				forceFullHeight: true,
				hideFooter: true,
				prefClass: null,
				store: transpose ? colorStore : itemStore,
				
				// custom properties
				columnStore: transpose ? itemStore : colorStore
			});

			view.defView.m_headings[0].m_name = this.stylesOnly ? locale.typeId("Style", "AssortmentStyles") : locale.resource("Assortment");
			view.placeAt(refNode);
			view.startup();

			// disable maximum width requirement for gallery properties
			domStyle.set(refNode.parentNode, "max-width", "initial");
		}
	});
});